export default __webpack_public_path__ + "static/media/person1.fd246fc5.jpg";